import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {AppComponent} from '../../../../app.component';
import {ActivatedRoute} from '@angular/router';
import {TokenService} from '../../../../core/auth';

@Component({
  selector: 'app-user-password-validation',
  templateUrl: './user-password-validation.component.html',
  styleUrls: ['./user-password-validation.component.scss']
})
export class UserPasswordValidationComponent implements OnInit, OnChanges {



  authUser = this.token.whoAmI();
  busy = false;
  error = false;

  @Input() newPassword: string;
  @Input() confirmPassword: string;

  @Output() changed: EventEmitter<boolean> = new EventEmitter<boolean>();

  status = {
    passwordLength: false,
    passwordsMatch: false,
    atLeastOneDigit: false,
    atLeastOneUpperCaseCharacter: false,
    atLeastOneLowerCaseCharacter: false,
    atLeastOneSpecialCharacter: false,
    notMatchEmail: false
  };



  constructor(
    private cdRef: ChangeDetectorRef,
    private app: AppComponent,
    private route: ActivatedRoute,
    private token: TokenService
  ) {
  }

  ngOnInit() {
    this.checkStatus();
    this.isOk();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkStatus();
    this.isOk();
  }

  checkStatus() {
    this.status.passwordLength = this.newPassword && this.newPassword.length >= 12 && this.newPassword.length <= 1024;
    this.status.passwordsMatch = this.newPassword && this.confirmPassword && this.newPassword === this.confirmPassword;
    this.status.atLeastOneDigit = this.newPassword && /\d+/g.test(this.newPassword);
    this.status.atLeastOneUpperCaseCharacter = this.newPassword && /[A-Z]/g.test(this.newPassword);
    this.status.atLeastOneLowerCaseCharacter = this.newPassword && /[a-z]/g.test(this.newPassword);
    this.status.atLeastOneSpecialCharacter = this.newPassword && /[!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/g.test(this.newPassword);
  }

  isOk() {
    let isOk =
      this.status.passwordLength
      && this.status.passwordsMatch
      && this.status.atLeastOneDigit
      && this.status.atLeastOneUpperCaseCharacter
      && this.status.atLeastOneLowerCaseCharacter
      && this.status.atLeastOneSpecialCharacter;

    this.changed.emit(isOk);
  }

}
